import { useHistory, useParams } from 'react-router-dom';
import React, { useState, useEffect, useRef } from 'react';
import store from 'store';
import useSWR from 'swr';
import Cookies from 'js-cookie';
import BabyDetails from './BabyDetails';
import SignUp from './SignUp';
import { getRequestOptions } from 'utils/api';
import { get, getSWR, post } from 'utils/api';
import { getChildJournal, postChildJournal, patchChildJournal } from 'child-journals/api';
import { useCurrentMember } from 'members/hooks/index';
import { calculatePricing } from 'app/payment/DashboardPrices';
import RedeemCertificate from './RedeemCertificate';
import OpenMyGift from './redeem/OpenMyGift';
import YourBookDetails from './redeem/YourBookDetails';
import { redemptionFromResponse } from './redeem/details';
import useLocation from 'app/hooks/location';
import { postMemberEvent } from 'members/api';
import { getAllPackages, getPrefixedEventName } from 'app/form/helper';
import ReadyToPurchase from './ReadyToPurchase';
import Wrapper from 'gift-certificate/Wrapper';
import PaymentPage from 'app/payment/PaymentPage';
import PaymentSuccess from 'app/payment/PaymentSuccess';
import { filterUTMParams } from 'members/helper';
import AddEmail from 'gift-certificate/AddEmail';
import { useDispatch } from 'react-redux';
import { togglefirstTimeUserFlowVisible } from 'stories/actions';
import ChooseYourPlanFMB from './ChooseYourPlanFMB';
import UserDetails from './UserDetails';
import OptionRenderer from 'gift-certificate/OptionRenderer';
import { Flex, Text, Button } from 'rebass';
import { FaCircleCheck } from 'react-icons/fa6';
import useEntityActionCreators from 'entities/hooks/use-entity-action-creators';
import { useMyAllChildJournals } from 'account-dashboard/hooks';
// import { getMyChildJournals } from 'account-dashboard/api';
// import { journalToPlain } from 'account-dashboard/hooks';


const BabysFirstYear = () => {
    const [currentChildJournalId, setCurrentChildJournalId] = useState(store.get('child_journal_id') || null);
    const [childJournalDetails, setChildJournalDetails] = useState(null);
    const [step, setStep] = useState(null);

    const [redeemCode, setRedeemCode] = useState(null);
    // Set once PATCH .../redeem succeeds — the redeemed certificate plus the
    // journal that transferred with it. Its presence is what advances the gift
    // recipient from "Open my gift" to "Your book details", so redemption is
    // never re-run on a re-render.
    const [redemption, setRedemption] = useState(null);
    const dispatch = useDispatch();
    const member = useCurrentMember();
    const { push, goBack } = useHistory();
    const { pathname, search } = useLocation();
    const params = useParams();
    const [orderSummary, setOrderSummary] = useState(null);
    const [generatingInvoice, setGeneratingInvoice] = useState(false);
    const [selectedPlan, setSelectedPlan] = useState(null);
    const { receive } = useEntityActionCreators();

    const [email, setEmail] = useState(member?.email);
    const [quantity, setRequiresQuantity] = useState(1);
    const [status, setStatus] = useState({ type: '', message: '' });
    const [restoreToken, setRestoreToken] = useState(null);

    const [orderQuantity, setOrderQuantity] = useState(1);
    const [createdCount, setCreatedCount] = useState(0);
    const [isLoadingCount, setIsLoadingCount] = useState(true);
    const [showSuccessMessage, setShowSuccessMessage] = useState(false);
    const [name_of_giver, setNameOfGiver] = useState(null);

    async function createNewRestoreToken() {
        const res = await post('/v2/restore_tokens');
        if (res.status === 201) {
            setRestoreToken(res?.data?.initial?.data?.attributes)
        } else {
            return null
        }
    }

    useEffect(() => {
        createNewRestoreToken()
    }, [])

    const isSubmittingRef = useRef(false);

    useEffect(() => {
        if (email !== member?.email)
            setEmail(member?.email)
    }, [member?.email])

    function getUrl() {
        let param = `?group=onboarding`;
        return `/v3/child_journals/product_packages${param}`;
    }

    const { data: mainData } = useSWR(getUrl(), getSWR);
    const { data: mainSurveyQuest } = useSWR(`v3/public/surveys/byb_fmb_purchase_v6`, getSWR);

    const areYouthe = mainSurveyQuest?.data?.included.find(({ attributes }) => attributes?.['question-text'] === "Are you the...")
    const howOldIsTheBaby = mainSurveyQuest?.data?.included.find(({ attributes }) => attributes?.['question-text'] === "How old is the baby?")
    const { journals } = useMyAllChildJournals();

    const areYoutheSurveyData = {
        id: mainSurveyQuest?.data?.data?.id,
        attributes: areYouthe?.attributes
    }

    const howOldIsTheBabySurveyData = {
        id: mainSurveyQuest?.data?.data?.id,
        attributes: howOldIsTheBaby?.attributes
    }

    const data = mainData?.data

    const calculatedPricing = calculatePricing(data, selectedPlan) || {};
    calculatedPricing.allPackages = getAllPackages(data)


    const { data: wmgData } = useSWR(`/v3/child_journals/product_packages?group=watch_me_grow`, getSWR);

    const wmgPackageData = wmgData?.data

    const calculatedPricingWMG = calculatePricing(wmgPackageData, selectedPlan) || {};
    calculatedPricingWMG.allPackages = getAllPackages(wmgPackageData)

    async function getGiftCertificateDetails() {
        try {
            const resp = await fetch(`${baseUrl}/v3/child_journals`, getRequestOptions());
            const response = await resp.json();
            if (response?.data === null || response?.errors?.length > 0) {
                return 0;
            }
            return Array.isArray(response?.data) ? response.data.filter(({ attributes }) => !!attributes?.['first-name']).length : 0;
        } catch (err) {
            return 0;
        }
    }

    // Resets form state and navigates back to Step 1 for the next certificate.
    async function handleStartNext() {

        if (isSubmittingRef.current) return;

        isSubmittingRef.current = true;
        const attributes = {
            'member-relation-name': childJournalDetails?.['member-relation-name'],
            'subject-relation': childJournalDetails?.['subject-relation'],
            // 'subject-pronoun': (childJournal && childJournal['subject-pronoun']) || ''
        };

        const body = {
            data: {
                attributes,
            },
        };

        setChildJournalDetails(null);
        setCurrentChildJournalId(null);
        const cjRes = await postChildJournal(body);


        // handleCertificateCreated();
        const [id] = cjRes.data.result['child-journals'];
        const freshCount = await getGiftCertificateDetails();

        const newCount = Math.max(freshCount, createdCount + 1);
        setCreatedCount(newCount);
        receive({ payload: cjRes });
        setCurrentChildJournalId(id)
        setShowSuccessMessage(false);
        isSubmittingRef.current = false;

        push(`?step=3${filterUTMParams(window?.location?.search)}`);
    }

    useEffect(() => {
        const queryParams = new URLSearchParams(search);

        const customerEmail = queryParams.get('customerEmail') || Cookies.get('customer_email');
        if (customerEmail)
            setEmail(decodeURIComponent(customerEmail))

    }, []);

    useEffect(() => {
        if (!calculatedPricing.allPackages?.freePlan || selectedPlan) return;
        if (!store.get('selectedPackageId') || calculatedPricing.allPackages?.freePlan?.id === store.get('selectedPackageId')) {
            setSelectedPlan(calculatedPricing.allPackages?.freePlan);
            return;
        } else {
            setSelectedPlan(calculatedPricing.allPackages?.paidPlans.find(({ id }) => {
                if (id === store.get('selectedPackageId')) {
                    setSelectedPlan(calculatedPricing.allPackages?.paidPlans.find(({ id }) => id === store.get('selectedPackageId')));
                    return true;
                }
                return false;
            }
            ))
        }
    }, [calculatedPricing.allPackages?.freePlan, selectedPlan])
    const isFromRedeemCertificate = pathname.includes('/redeem-gift-certificate');

    async function generateInvoice(postalCode) {
        setGeneratingInvoice(true)
        setOrderSummary(null)
        const res = await post(`/v3/product_packages/${calculatedPricing?.packageId || store.get('selectedPackageId')}/invoices` +
            (quantity !== undefined ? `?quantity=${quantity}` : '') +
            (postalCode ? `&postal_code=${postalCode}` : '')
        );
        if (res.status === 200) {
            const lineItems = res?.data?.initial?.data?.relationships?.['line-items']?.data || [];
            const lineItemsDetails = lineItems.map(lineItem => ({
                ...res?.data?.initial?.included.find(({ id, type }) => id === lineItem?.id && type.includes(lineItem?.type))?.attributes,
                id: lineItem?.id,
            }));
            setOrderSummary({
                ...res?.data?.initial?.data?.attributes,
                lineItems: lineItemsDetails,
            });
            setGeneratingInvoice(false)
            return { ...res?.data?.initial?.data?.attributes, ...res?.data?.initial?.included.find(({ id, type }) => id === lineItems?.id && type.includes(lineItems?.type))?.attributes, id: res?.data?.initial?.data?.id }
        }
        else {
            setGeneratingInvoice(false)
            return false
        }
    }

    const getChildJournalDetails = async (storyId) => {
        const { data } = await getChildJournal(storyId);
        setChildJournalDetails(data?.entities?.['child-journals'][storyId]);
    };

    function renderheader() {
        return orderQuantity > 1 && (
            <Flex
                justifyContent="center"
                alignItems="center"
                py={3}
                sx={{
                    gap: '10px', mt: '40px', zIndex: 1,
                    ':after': {
                        display: 'block',
                        width: '185px',
                        height: 3,
                        backgroundColor: '#763099',
                        margin: '10px 0px',
                        content: '" "',
                    },
                    ':before': {
                        display: 'block',
                        width: '185px',
                        height: 3,
                        backgroundColor: '#763099',
                        margin: '10px 0px',
                        content: '" "',
                    },
                }}
            >
                <Text
                    fontFamily="Poppins"
                    fontWeight={600}
                    fontSize={15}
                    color="#763099"
                    minWidth='90px'
                    textAlign={'center'}
                >
                    Child {createdCount + 1} of {orderQuantity}
                </Text>
            </Flex>
        )
    }

    const fetchFirstChildJournal = async () => {
        setIsLoadingCount(true);

        const { data, status } = await getSWR('/v3/child_journals');
        if (status === 200 && data?.data?.length > 0) {
            const childJournals = data?.data;

            const childJournalsFilteres = childJournals?.filter(({ attributes }) =>
                attributes?.['subject-name'] !== "Tap for Intro" &&
                attributes?.['subject-name'] !== 'Sample Child Journal'
            ).sort((a, b) => new Date(a.attributes.createdAt) - new Date(b.attributes.createdAt));

            const firstJournal = childJournalsFilteres[0]


            setCreatedCount(childJournalsFilteres.filter(({ attributes }) => !!attributes?.['first-name']).length);
            setIsLoadingCount(false);

            if (firstJournal) {
                setCurrentChildJournalId(firstJournal?.attributes?.id)
                getChildJournalDetails(firstJournal?.attributes?.id);
                if (step !== 10 && window.location.search !== '?step=2' && window.location.search !== '?step=3') {
                    if (firstJournal?.attributes?.['has-baby-year-books-subscription'] || firstJournal?.attributes?.['has-watch-me-grow-subscription'])
                        push(`/child-journals/${firstJournal.id}`);
                    // else
                    // handleStepChange(7) // send user to shopify dev page
                }
            }
        } else {
            if (member?.['has-username-password-identifier'] && step !== 2 && window.location.search !== '?step=2')
                handleStepChange(2)
        }
    };

    const handleStepChange = (newStep) => {
        if (restoreToken) {
            push(`?step=${newStep}${filterUTMParams(window?.location?.search)}&restoreTokenId=${restoreToken?.id}&restoreTokenSecret=${restoreToken?.secret}`)
        }
        else
            push(`?step=${newStep}${filterUTMParams(window?.location?.search)}`)
    };

    async function firePostMemberEvent(eventName, journalId = undefined) {
        if (currentChildJournalId || journalId) {
            postMemberEvent(getPrefixedEventName(eventName), {
                'subject-type': 'ChildJournal',
                'subject-id': journalId || currentChildJournalId,
            })
        } else
            postMemberEvent(getPrefixedEventName(eventName))
    }

    useEffect(() => {
        if (currentChildJournalId) {
            getChildJournalDetails(currentChildJournalId);
        }
    }, [currentChildJournalId]);

    useEffect(() => {
        if (member?.['has-username-password-identifier'] && !redeemCode && !location.pathname.includes('/redeem-gift-certificate')) {
            setTimeout(fetchFirstChildJournal, 1000);
        }
    }, [member?.['has-username-password-identifier'], redeemCode]);

    const orderQuantityInitializedRef = useRef(false);

    useEffect(() => {
        const queryParams = new URLSearchParams(search);

        const raw = queryParams.get('orderQuantity');
        // Read orderQuantity once from the landing URL. It must not be re-read
        // on subsequent step navigations because those URLs no longer carry it.
        if (!orderQuantityInitializedRef.current) {
            orderQuantityInitializedRef.current = true;
            const parsed = parseInt(raw, 10);
            if (Number.isFinite(parsed) && parsed > 0) {
                setOrderQuantity(parsed);
            }
        }

        const stepFromUrl = queryParams.get('step');

        const latestRedeemCode = queryParams.get('redeemCode');
        if (stepFromUrl) {
            setStep(parseInt(stepFromUrl, 10));
            if (params?.id || (pathname.includes('/redeem-gift-certificate')) || latestRedeemCode)
                setRedeemCode(params?.id || latestRedeemCode);
        } else if (params?.id || (pathname.includes('/redeem-gift-certificate')) || latestRedeemCode) {
            firePostMemberEvent('')
            handleStepChange(0)
            setRedeemCode(params?.id || null || latestRedeemCode);
        } else {
            firePostMemberEvent('how_old_is_the_baby')
            handleStepChange(1)
        }
    }, [params, pathname]);

    useEffect(() => {
        if (childJournalDetails?.['has-baby-year-books-subscription'] && currentChildJournalId && (step !== 10 && window.location.search !== '?step=10' && window.location.search !== '?step=9') && member?.['has-username-password-identifier'])
            push(`/child-journals/${currentChildJournalId}`)
    }, [childJournalDetails?.['has-baby-year-books-subscription'], currentChildJournalId, member?.['has-username-password-identifier']])

    useEffect(() => {
        window.scrollTo(0, 0);
        const initializeOrderQuantity = async () => {
            const queryParams = new URLSearchParams(search);
            const orderParamQuantity = queryParams.get('orderQuantity');
            if ((orderParamQuantity === null || orderParamQuantity === 'null') && orderQuantity === 1) {
                try {
                    const shopifyOrderId = queryParams.get('shopifyOrderId');

                    if (shopifyOrderId) {
                        const { data: shopifyOrdersData } = await get(
                            `/v3/shopify_orders/${shopifyOrderId}`
                        );

                        const quantity = shopifyOrdersData?.initial?.data?.attributes?.['quantity'];

                        if (quantity) {
                            setOrderQuantity(quantity);
                        }
                    }
                } catch (error) {
                    setOrderQuantity(1); // ✅ Fallback to 1
                }
            }
        };
        if (step === 3)
            initializeOrderQuantity();
    }, [step]);

    useEffect(() => {
        if (!redeemCode && (step === 4 || step === 5 || step === 6) && (calculatedPricing?.packageId || store.get('selectedPackageId'))) {
            generateInvoice()
        }
    }, [redeemCode, step, calculatedPricing?.packageId, quantity]);

    function skiptoStep(jumpToStep, eventName) {
        if (typeof jumpToStep === 'number') {
            if (redeemCode && isFromRedeemCertificate) {
                if (restoreToken)
                    push(`/redeem-gift-certificate/${redeemCode}?step=${jumpToStep}${filterUTMParams(window?.location?.search)}&restoreTokenId=${restoreToken?.id}&restoreTokenSecret=${restoreToken?.secret}`)
                else
                    push(`/redeem-gift-certificate/${redeemCode}?step=${jumpToStep}${filterUTMParams(window?.location?.search)}`)
            }
            else {
                handleStepChange(jumpToStep)
            }
            firePostMemberEvent(eventName || 'save_20_today')
        }
        else {
            if (eventName)
                firePostMemberEvent(eventName)
            if (redeemCode && isFromRedeemCertificate)
                if (restoreToken)
                    push(`/redeem-gift-certificate/${redeemCode}?step=${step + 1}${filterUTMParams(window?.location?.search)}&restoreTokenId=${restoreToken?.id}&restoreTokenSecret=${restoreToken?.secret}`)
                else
                    push(`/redeem-gift-certificate/${redeemCode}?step=${step + 1}${filterUTMParams(window?.location?.search)}`)
            else {
                handleStepChange(step + 1)
            }
        }
    }

    const renderStep = () => {
        switch (step) {
            case 0:
                return (
                    <RedeemCertificate
                        firePostMemberEvent={firePostMemberEvent}
                        redeemCode={redeemCode}
                        setRedeemCode={setRedeemCode}
                        setNameOfGiver={setNameOfGiver}
                        onStepUp={(jumpToStep) => {
                            if (member?.['has-username-password-identifier']) {
                                skiptoStep(8, 'open_my_gift')
                            } else
                                skiptoStep(jumpToStep, 'how_old_is_the_baby')
                        }}
                        onStepDown={() => handleStepChange(step - 1)}
                    />
                );
            // case 1:
            //     return (
            //         <OptionRenderer
            //             surveyData={howOldIsTheBabySurveyData}
            //             firePostMemberEvent={firePostMemberEvent}
            //             onStepUp={(jumpToStep) => {
            //                 skiptoStep(jumpToStep, 'are_you_the_mom')
            //             }}
            //         />
            //     );
            // case 2:
            //     return (
            //         <OptionRenderer
            //             surveyData={areYoutheSurveyData}
            //             firePostMemberEvent={firePostMemberEvent}
            //             onStepDown={() => handleStepChange(step - 1)}
            //             onStepUp={(jumpToStep) => {
            //                 skiptoStep(jumpToStep, 'cherish_the_story_of_your_baby')
            //             }}
            //         />
            //     );
            // case 3:
            //     return <ChooseYourPlanFMB
            //         isForMyBaby
            //         onStepUp={(jumpToStep) => {
            //             if (redeemCode)
            //                 skiptoStep(8, 'create_your_account')
            //             else
            //                 skiptoStep(undefined, 'select_your_plan')
            //         }}
            //         onStepDown={() => handleStepChange(step - 1)}
            //     />;
            // case 4:
            //     return (
            //         <ReadyToPurchase
            //             selectedPlan={selectedPlan}
            //             setSelectedPlan={setSelectedPlan}
            //             allPackages={calculatedPricing.allPackages}
            //             redeemCode={redeemCode}
            //             setStatus={setStatus}
            //             setRedeemCode={setRedeemCode}
            //             hideSkip
            //             firePostMemberEvent={firePostMemberEvent}
            //             quantity={quantity}
            //             member={member}
            //             email={email}
            //             setEmail={setEmail}
            //             currentChildJournalId={currentChildJournalId}
            //             calculatedPricing={calculatedPricing}
            //             setRequiresQuantity={setRequiresQuantity}
            //             status={status}
            //             onStepUp={(jumpToStep) => {
            //                 if (status.type !== 'success' && jumpToStep?.title?.includes('Watch Me Grow')) {
            //                     // skiptoStep(undefined, 'where_should_we_send_receipt')
            //                     if (restoreToken)
            //                         push(`/watch-me-grow/get-started?step=1${filterUTMParams(window?.location?.search)}&restoreTokenId=${restoreToken?.id}&restoreTokenSecret=${restoreToken?.secret}`)
            //                     else
            //                         push(`/watch-me-grow/get-started?step=1${filterUTMParams(window?.location?.search)}`)
            //                 } else {
            //                     skiptoStep(8, 'create_your_account')
            //                 }
            //             }}
            //             onStepDown={() => handleStepChange(step - 1)}
            //             generateInvoice={generateInvoice}
            //             isForMyBaby
            //             isFromRedeemCertificate={isFromRedeemCertificate}
            //             orderSummary={orderSummary}
            //             calculatedPricingWMG={calculatedPricingWMG}
            //         />
            //     );
            // case 5:
            //     return (
            //         <AddEmail
            //             redeemCode={redeemCode}
            //             setRedeemCode={setRedeemCode}
            //             hideSkip
            //             firePostMemberEvent={firePostMemberEvent}
            //             quantity={quantity}
            //             member={member}
            //             email={email}
            //             setEmail={setEmail}
            //             calculatedPricing={calculatedPricing}
            //             setRequiresQuantity={setRequiresQuantity}
            //             onStepUp={(jumpToStep) => {
            //                 if (jumpToStep)
            //                     skiptoStep(jumpToStep, 'create_your_account')
            //                 else {
            //                     skiptoStep(undefined, 'review_and_complete_your_order')
            //                 }
            //             }}
            //             onStepDown={() => handleStepChange(step - 1)}
            //             generateInvoice={generateInvoice}
            //             isForMyBaby
            //             isFromRedeemCertificate={isFromRedeemCertificate}
            //             orderSummary={orderSummary}
            //         />
            //     );
            // case 6:
            //     return (
            //         <Wrapper
            //             hideSkip
            //             percentComplete={100}
            //             showFooter={false}
            //         >
            //             <PaymentPage
            //                 generatingInvoice={generatingInvoice}
            //                 isForMyBaby
            //                 backText="Back"
            //                 onBack={() => handleStepChange(step - 1)}
            //                 onStepUp={() => skiptoStep(undefined, 'thank_you_for_your_purchase')}
            //                 quantity={quantity}
            //                 currentChildJournalId={currentChildJournalId}
            //                 calculatedPricing={calculatedPricing}
            //                 selectedPlan={selectedPlan}
            //                 orderSummary={orderSummary}
            //                 generateInvoice={generateInvoice}
            //                 firePostMemberEvent={firePostMemberEvent}
            //             />
            //         </Wrapper>
            //     );
            // case 7:
            //     return <PaymentSuccess
            //         isForMyBaby
            //         quantity={quantity}
            //         orderSummary={orderSummary}
            //         calculatedPricing={calculatedPricing}
            //         currentChildJournalId={currentChildJournalId}
            //         attributes={childJournalDetails}
            //         onStepUp={() => member?.['has-username-password-identifier'] ? skiptoStep(9, 'about_your_baby') : skiptoStep(undefined, 'create_your_account')}
            //     />
            case 1:
                return (
                    <SignUp
                        disabledEmail={!!email}
                        usersEmail={email}
                        isForMyBaby
                        hideSkip
                        firePostMemberEvent={firePostMemberEvent}
                        isLogin={false}
                        redemptionStatus={status}
                        redeemCode={redeemCode}
                        percentComplete={25}
                        step={step}
                        onStepUp={() => skiptoStep(undefined, 'about_yourself')}
                        // Redemption: advance to "Open my gift" once the account
                        // exists. `onDone` (unlike onStepUp) fires after BOTH
                        // signup and login, so a returning recipient who signs in
                        // reaches the gift too.
                        onDone={() => {
                            if (redeemCode) {
                                skiptoStep(8, 'open_my_gift')
                            }
                        }}
                        // onStepDown={() => {
                        //     goBack()
                        //     // skiptoStep(4, 'select_your_plan')
                        // }}
                        attributes={childJournalDetails}
                        journalId={currentChildJournalId}
                        setCurrentChildJournalId={setCurrentChildJournalId}
                    />
                );
            // ── Gift redemption ──────────────────────────────────────────────
            // Step 8: "Open my gift" → PATCH .../redeem.
            // Step 9: "Your book details" (+ confetti) → hands off to the shared
            //         set-up component for About-the-baby / relationship.
            case 8:
                if (redemption) {
                    return (
                        <YourBookDetails
                            entitlements={redemption.entitlements}
                            onStart={() => {
                                push(
                                    `/account/setup/${redemption.journalId}?flow=redemption&step=${journals.length > 1 ? 'child' : 'baby'}`
                                )
                            }}
                        />
                    );
                }
                return (
                    <OpenMyGift
                        couponCode={redeemCode || params?.id}
                        onRedeemed={async response => {
                            // const resp = await getChildJournal(redemptionFromResponse(response)?.id);
                            // const journals = resp?.data?.initial?.data?.map(journalToPlain);

                            setRedemption(redemptionFromResponse(response))
                        }}
                    />
                );
            case 2:
                return <UserDetails
                    hideSkip
                    redeemCode={redeemCode}
                    journalId={currentChildJournalId}
                    childJournalDetails={childJournalDetails}
                    onStepUp={(id) => {
                        skiptoStep(undefined, 'about_your_baby')
                    }}
                    attributes={childJournalDetails}
                    setChildJournalId={setCurrentChildJournalId}
                />
            case 3:
                return <BabyDetails
                    hideSkip
                    renderheader={renderheader}
                    redeemCode={redeemCode}
                    journalId={currentChildJournalId}
                    setChildJournalDetails={setChildJournalDetails}
                    onStepDown={() => handleStepChange(step - 1)}
                    // onStepDown={() => {
                    //     handleStepChange(step - 6)
                    // }}
                    onStepUp={async (id) => {
                        if (redeemCode) {
                            await patchChildJournal({ id: id || childJournalDetails?.id, state: 'initialized' });
                            push(`/account/gifts`);
                            return
                        }
                        // firePostMemberEvent('complete', id || childJournalDetails.id)
                        // dispatch(togglefirstTimeUserFlowVisible(true))
                        // push(`/child-journals/${id || childJournalDetails.id}`)
                        // skiptoStep(undefined, 'about_yourself')
                        store.remove('selectedPackageId')
                        firePostMemberEvent('complete', id || childJournalDetails?.id)


                        if ((createdCount + 1) >= orderQuantity) {
                            dispatch(togglefirstTimeUserFlowVisible(true))
                            push(`/child-journals/${id || childJournalDetails?.id}`)
                        }
                        else {
                            setShowSuccessMessage(true)
                        }
                        // handleStepChange(step + 1)
                    }}
                    attributes={childJournalDetails}
                    setChildJournalId={setCurrentChildJournalId}
                />

            default:
                return null;
        }
    };

    if (showSuccessMessage) {
        return (
            <Flex
                flexDirection="column"
                alignItems="center"
                justifyContent="center"
                height="100vh"
                p={4}
                mt={5}
            >
                <FaCircleCheck size={60} color="#C2FFD3" style={{ marginBottom: 16 }} />
                <Text
                    fontSize={[26, 30]}
                    fontFamily="Bitter"
                    color="#0E0E0E"
                    textAlign="center"
                    lineHeight={"120%"}
                    mb={2}
                >
                    New child added to Baby Yearbooks!
                </Text>
                <Text
                    fontFamily="Poppins"
                    color="#64748B"
                    textAlign="center"
                    fontSize={18}
                    mb={4}
                >
                    Please continue by adding your next child
                </Text>
                <Button
                    onClick={handleStartNext}
                    px={4}
                    py={3}
                    disabled={isSubmittingRef?.current}
                    className={isSubmittingRef?.current ? 'loading' : ''}
                    sx={{
                        borderRadius: 'medium',
                        fontSize: 16,
                        fontWeight: 600,
                        fontFamily: 'Poppins',
                        cursor: 'pointer',
                    }}
                >
                    {isSubmittingRef?.current ? 'Loading' : 'Continue'}
                </Button>
            </Flex>
        );
    }

    return <>
        {renderStep()}
        {/* <Box display={step === 4 ? 'block' : 'none'}>
            <FAQSection
                isForMyBaby
                hideSkip={isFromRedeemCertificate}
                firePostMemberEvent={firePostMemberEvent}
                onStepUp={(jumpToStep) => {
                    if (isFromRedeemCertificate) {
                        if (member?.['has-username-password-identifier'])
                            skiptoStep(10, 'about_your_baby')
                        else
                            skiptoStep(9, 'create_your_account')
                    }
                    else
                        skiptoStep(jumpToStep, 'purchase_details')
                }}
                onStepDown={() => handleStepChange(step - 1)}
            />
        </Box> */}
    </>
};

export default BabysFirstYear;
